import { Button, InputNumber, Modal, notification, Tabs } from 'antd'
import { debounce, isNumber } from 'lodash'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { GiaMinMax, getBankTransferContent, typeFund } from 'src/helpers/constants'
import { formatCurrency } from 'src/helpers/functions'
import { useStore } from 'src/hooks'
import { ROUTER_PATH } from 'src/screens/routes/metaData'
import { PENDING_PAYMENT_KEY } from 'src/screens/payment'
import TopupPingPongTab from './TopupPingPongTab'

const { TabPane } = Tabs

type TopupModalProps = {
   isTopupModalOpen: boolean
   handleCancel: () => void
}

const TopupModal: React.FC<TopupModalProps> = ({ isTopupModalOpen, handleCancel }) => {
   const FundStore = useStore('FundStore')
   const AuthStore = useStore('AuthStore')
   const CommonConfigStore = useStore('CommonConfigStore')
   const history = useHistory()
   const [amount, setAmount] = useState<any>(null)
   const { t } = useTranslation()
   const [activeTab, setActiveTab] = useState('bank')

   const handleChangeAmount = (value: any) => {
      setAmount(value)
   }

   const onClose = () => {
      setAmount(null)
      setActiveTab('bank')
      handleCancel()
   }

   // Số tiền không hợp lệ
   const invalidAmount =
      !amount ||
      !isNumber(amount) ||
      (CommonConfigStore?.designerConfigList?.minRecharge &&
         parseInt(amount + '') < parseInt(CommonConfigStore?.designerConfigList?.minRecharge + ''))

   const handleApplyTopup = async () => {
      if (invalidAmount) {
         notification.open({
            message: t(GLOBAL_CLIENT.thongbao),
            description: t(GLOBAL_CLIENT.errorNapTien).replace(
               '{0}',
               CommonConfigStore?.designerConfigList?.minRecharge
            )
         })
         return
      }

      const code = CommonConfigStore.bankAccount?.DESCRIPTION || ''
      const priceUSD = parseInt(amount + '') / CommonConfigStore?.designerConfigList?.exchangeRate
      const params = {
         price: priceUSD,
         priceVND: amount,
         code,
         description: t(GLOBAL_CLIENT.sellernaptien),
         type: typeFund.RECHARGE
      }

      const result = await FundStore.createFund(params)
      if (result?.code === 200) {
         const fundCode = result?.data?.code || code
         const content = getBankTransferContent(fundCode)

         sessionStorage.setItem(
            PENDING_PAYMENT_KEY,
            JSON.stringify({
               amount,
               code: fundCode,
               content,
               bankAccount: CommonConfigStore.bankAccount
            })
         )
         onClose()
         history.push(`/${ROUTER_PATH.PaymentScreen}`)
      } else {
         notification.error({
            message: t(GLOBAL_CLIENT.thongbao),
            description: result?.message || 'Tạo lệnh nạp tiền thất bại'
         })
      }
   }

   const renderBankTransferTab = () => (
      <div>
         <div
            className="ant-upload-hint"
            style={{
               paddingTop: 12,
               paddingBottom: 12,
               fontSize: 12,
               textAlign: 'center',
               fontStyle: 'italic',
               color: invalidAmount ? 'red' : '#888'
            }}
         >
            Số tiền nạp tối thiểu là {formatCurrency(CommonConfigStore?.designerConfigList?.minRecharge, true)} đ
         </div>

         <div style={{ textAlign: 'center', marginTop: 8 }}>
            <InputNumber
               style={{ width: '100%' }}
               placeholder={t(GLOBAL_CLIENT.sotienmuonnap) + ' (VNĐ)'}
               formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
               parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               min={GiaMinMax.minNap}
               max={GiaMinMax.maxNap}
               step={1000}
               onChange={(value: any) => handleChangeAmount(value)}
            />
         </div>

         {amount && isNumber(amount) && (
            <div style={{ paddingTop: 8, textAlign: 'center' }}>
               {`Tỉ giá: ${formatCurrency(
                  CommonConfigStore?.designerConfigList?.exchangeRate,
                  true
               )}đ  -  Quy đổi USD: $${formatCurrency(
                  parseFloat(amount + '') / CommonConfigStore?.designerConfigList?.exchangeRate
               )}`}
            </div>
         )}

         <div
            style={{
               width: '100%',
               marginTop: 24,
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               gap: 12
            }}
         >
            <Button type="dashed" onClick={onClose}>
               {t(GLOBAL_CLIENT.huy)}
            </Button>
            <Button type="primary" onClick={debounce(handleApplyTopup, 500)} disabled={invalidAmount}>
               {t(GLOBAL_CLIENT.xacnhancktc)}
            </Button>
         </div>
      </div>
   )

   return (
      <Modal
         maskClosable={false}
         closable={false}
         title={t(GLOBAL_CLIENT.deposit)}
         visible={isTopupModalOpen}
         onCancel={onClose}
         footer={null}
         width={activeTab === 'pingpong' ? 700 : 520}
      >
         <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)}>
            <TabPane tab="Chuyển khoản ngân hàng" key="bank">
               {renderBankTransferTab()}
            </TabPane>
            <TabPane tab="PingPong" key="pingpong">
               <TopupPingPongTab
                  onClose={onClose}
                  exchangeRatePingpong={
                     CommonConfigStore?.designerConfigList?.exchangeRatePingpong ||
                     CommonConfigStore?.designerConfigList?.exchangeRate ||
                     1
                  }
                  minRechargePingpong={CommonConfigStore?.designerConfigList?.minRechargePingpong}
               />
            </TabPane>
         </Tabs>
      </Modal>
   )
}

export default TopupModal
